import { CapturedCard, GlobalLoader, NoDataFound } from "components/UiElement";
import { Container, Row } from "react-bootstrap";
import { useEffect, useState } from "react";

import { logger } from "utils";
import { CreateMemoriesService } from "services";
import { useTranslation } from "react-i18next";
import CapturedModel from "../CapturedModel";

function CapturedSection({ id, capturedData, getCapturedData, loading }) {
  const [showModal1, setShowModal1] = useState(false);
  const [photoData, setPhotoData] = useState({});
  const { t } = useTranslation();

  const getPhotoData = async (ids) => {
    try {
      const res = await CreateMemoriesService.getMemorialAlbumService(ids);
      const { data, success } = res;
      if (success) {
        setPhotoData(data);
      }
    } catch (error) {
      logger(error);
    }
  };

  useEffect(() => {
    if (id) {
      getCapturedData(id);
    }
  }, [id]);

  const handleCloseModal1 = () => {
    setShowModal1(false);
    setPhotoData({});
  };

  const openImageModal1 = (memorialId) => {
    setShowModal1(!showModal1);
    getPhotoData(memorialId);
  };

  return (
    <>
      {capturedData?.length > 0 && (
        <>
          {" "}
          {loading ? (
            <GlobalLoader />
          ) : (
            <section className="captured py-80" id="gallery">
              <Container>
                <div className="commonHead text-center">
                  <div className="commonHead_sub">
                    {t("text.createMemories.photoVideo")}{" "}
                  </div>
                  <h2 className="commonHead_title">
                    {t("text.createMemories.capturedMemories")}
                  </h2>
                </div>
                <div className="captured_inner">
                  {capturedData?.length > 0 ? (
                    <Row className="gy-3 gy-lg-4">
                      {capturedData?.length > 0 &&
                        capturedData.map((item) => {
                          return (
                            <CapturedCard
                              item={item}
                              openImageModal1={openImageModal1}
                            />
                          );
                        })}
                    </Row>
                  ) : (
                    <NoDataFound />
                  )}
                </div>
              </Container>
            </section>
          )}
        </>
      )}
      <CapturedModel
        handleCloseModal1={handleCloseModal1}
        showModal1={showModal1}
        photoData={photoData}
      />
    </>
  );
}

export default CapturedSection;
